<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="searchbox">
			<div style="height:72px;display: flex;align-items: center;justify-content: space-between;width: 100%;">
				<div style="display: flex;align-items: center;">
					<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword"
						@keyup.enter.native="clickSearch" clearable size="small"></el-input>
					<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
				</div>
				<el-button icon="el-icon-plus" type="warning" @click='addBannerOption()' size="small" style="margin-left: 10px;">新建</el-button>
			</div>
		</div>
		<div class="con" :style="{height:fixedHeight-82+'px'}">
			<el-table :data="bannerData" style="width: 100%">
				<el-table-column label="广告名称" prop="title">
				</el-table-column>
				<el-table-column prop="system_info.project_name" label="广告来源">
				</el-table-column>
				<el-table-column label="广告位置" prop="location_info.project_name">

				</el-table-column>
				<el-table-column label="广告周期" width="200">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.begin_time,'YYYY-MM-DD')}} 至
							{{$public.FTime(scope.row.end_time,'YYYY-MM-DD')}}</span>
					</template>
				</el-table-column>

				<el-table-column label="广告状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status ==1">未开始</span>
						<span v-if="scope.row.status ==2">进行中</span>
						<span v-if="scope.row.status ==3">已结束</span>
						<span v-if="scope.row.status ==4">暂停</span>
					</template>
				</el-table-column>
				<el-table-column label="更新人">
					<template slot-scope="scope">
						<span>{{scope.row.create_user.operation_user.user_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="更新时间">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.create_user.operation_time,'YYYY-MM-DD')}}</span>
					</template>
				</el-table-column>


				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<el-button type="text" icon='el-icon-edit' size="small" @click='edit(scope.row._id)'>编辑
						</el-button>
						<el-button v-if="scope.row.status==4" type="text"  size="small"
							@click='start(scope.row._id,scope.row.title)'>开启</el-button>
						<el-button v-if="scope.row.status==2" type="text"  size="small"
							@click='stop(scope.row._id,scope.row.title)'>暂停</el-button>
						<el-button type="text" icon='el-icon-dele te' size="small"
							@click='deleted(scope.row._id,scope.row.title)'>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page :total="total" :page="params.page_index" :pageSize='params.page_size' @change="changePage" style="padding: 10px 0;"></page>
		</div>
		
		<el-dialog title="广告设置" :visible.sync="dialogAdvertising" width="30%" :close-on-click-modal='false'>
			<el-form label-width="80px">
				<el-form-item label="广告名称">
					<el-input v-model="editParams.title" size='mini' style="width: 130px;"></el-input>
				</el-form-item>
				<el-form-item label="广告位置">
					<el-cascader ref='cascader' clearable size='mini' v-model="locationids" :options="locationData"
						:props="{ value:'project_id',label:'project_name',children:'location_list'}"
						@change="handleChange"></el-cascader>
				</el-form-item>
				<el-form-item label="图片跳转链接" label-width="100px">
					<el-input v-model="editParams.url_param" size='mini' style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="广告周期">
					<el-date-picker size="mini" style="width: 220px;" v-model="datevalue" type="daterange"
						value-format='timestamp' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						@change="changeDate">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="广告图片">
					<el-upload class="avatar-uploader" action="action" :show-file-list="false"
						:http-request="uploadimg">
						<img v-if="editParams.pic_url" :src="editParams.pic_url" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="warning" @click="onSubmit">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


	</div>
</template>

<script>
	import page from "../../components/page.vue"
	import {
		uploadImg
	} from '../../api/stockApi.js'
	import {
		getBannerList,
		addBanner,
		getLocation,
		deleteBanner,
		getBannerDl,
		startBanner,
		stopBanner,
		updateBanner
	} from '../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				datevalue: '',
				dialogAdvertising: false,
				bannerData: [],
				params: {
					keyword: '',
					system_id: '',
					location_id: '',
					status: -1,
					page_index: 1,
					page_size: 10,
				},
				editParams: {
					title: '',
					system_info: {
						project_id: '',
						project_name: '',
					},
					location_info: {
						project_id: '',
						project_name: '',
					},
					pic_url: '',
					begin_time: '',
					end_time: '',
					url_param:'',
				},
				locationids: [],
				total: 0,
				categoryData: [],
				locationData: [],
				goodsFile: [],
				fixedHeight:'',
			}
		},

		methods: {
			getBannerList() {
				getBannerList(this.params).then(res => {
					if (res.code == 0) {
						this.bannerData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			getLocation() {
				getLocation().then(res => {
					if (res.code == 0) {
						this.locationData = res.data;
					}
				})
			},
			clickSearch() {
				this.params.page_index = 1;
				this.getBannerList();
			},
			changePage(val) {
				this.params.page_index = val;
				this.getBannerList();
			},
			addBannerOption() {
				this.dialogAdvertising = true;
				this.editParams = {
					title: '',
					system_info: {
						project_id: '',
						project_name: '',
					},
					location_info: {
						project_id: '',
						project_name: '',
					},
					pic_url: '',
					begin_time: '',
					end_time: '',
					url_param:'',
				};
				this.goodsFile = [];
				this.locationids = [];
				this.datevalue = '';

			},

			edit(id) {
				this.dialogAdvertising = true;
				getBannerDl({
					id
				}).then(res => {
					if (res.code == 0) {
						this.editParams = res.data;
						this.locationids = [res.data.system_info.project_id, res.data.location_info.project_id]
						this.datevalue = [res.data.begin_time * 1000, res.data.end_time * 1000]
						this.goodsFile = JSON.parse(res.data.pic_url);
					}
				})
			},
			deleted(id, name) {
				console.log(id);
				this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteBanner({
						id,
						name
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getBannerList();
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			lookdetail(id) {
				console.log(id);
			},
			handleChange(val) {
				if (val.length > 0) {
					this.editParams.system_info.project_id = this.$refs.cascader.getCheckedNodes()[0].parent.value;
					this.editParams.system_info.project_name = this.$refs.cascader.getCheckedNodes()[0].parent.label;
					this.editParams.location_info.project_id = this.$refs.cascader.getCheckedNodes()[0].value;
					this.editParams.location_info.project_name = this.$refs.cascader.getCheckedNodes()[0].label;

				} else {
					this.editParams.system_info.project_id = '';
					this.editParams.system_info.project_name = '';
					this.editParams.location_info.project_id = '';
					this.editParams.location_info.project_name = '';
				}
				console.log(this.editParams);
			},



			onSubmit() {
				if (!this.editParams.title) {
					this.$message({
						type: 'warning',
						message: '名称不能为空'
					});
				} else {
					if(this.editParams._id){
						updateBanner(this.editParams).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '设置成功'
							});
							this.dialogAdvertising = false;
							this.getBannerList();
						}
					})	
					}else{
					addBanner(this.editParams).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '设置成功'
							});
							this.dialogAdvertising = false;
							this.getBannerList();
						}
					})	
					}
					
				}

			},
			
			changeDate(val) {
				this.editParams.begin_time = val[0] / 1000;
				this.editParams.end_time = val[1] / 1000
			},
			stop(id, name) {
				stopBanner({
					id,
					name
				}).then(res => {
					if(res.code==0){
						
					this.$message({
						type: 'success',
						message: '设置成功'
					});
					this.getBannerList();}
				})
			},
			start(id, name) {
				startBanner({
					id,
					name
				}).then(res => {
					if(res.code==0){
					this.$message({
						type: 'success',
						message: '设置成功'
					});
					this.getBannerList();}
				})
			},
			uploadimg(item) {
				var formData = new FormData();
				formData.append('img', item.file);
				uploadImg(formData).then(res => {
					if (res.code == 0) {
						this.editParams.pic_url = res.data.url;
					}
				})
			},


		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 86;
			this.getBannerList();
			this.getLocation();
		}
	}
</script>

<style lang="scss">
	.page {
		.searchbox {
			background-color: #fff;
			height: 72px;
			padding: 0 20px;
		}

		.con {
			margin-top: 10px;
			background: #fff;
		}
		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}
		
		.avatar-uploader .el-upload:hover {
			border-color: #409EFF;
		}
		
		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 158px;
			height: 158px;
			line-height: 158px;
			text-align: center;
		}
		
		.avatar {
			width: 158px;
			height: 158px;
			display: block;
			object-fit: cover;
		}
	}
</style>
